import { isNotDefined } from '@sgme/fp';
import { IntlFormatters } from 'react-intl';

export const getEsgEligibilityTranslateMessageByEligibility = (
  formatMessage: IntlFormatters['formatMessage'],
  isEligible?: boolean,
  isEligibleWithCondition?: boolean,
) => {
  if (isNotDefined(isEligible) && isNotDefined(isEligibleWithCondition)) {
    return '';
  }

  if (isEligible) {
    return formatMessage({ id: 'underlying.esgEligibility.eligible' });
  }

  if (isEligibleWithCondition) {
    return formatMessage({ id: 'underlying.esgEligibility.eligibleWithCondition' });
  }

  return formatMessage({ id: 'underlying.esgEligibility.ineligible' });
};
